export default __webpack_public_path__ + "static/media/2.5108e5d4.jpeg";